import { styled } from '@/stitches.config';

export const NavStyled = styled('nav', {
  flexGrow: 1,
  paddingLeft: '$4',
});

export const NavigationListStyled = styled('ul', {
  margin: '$0',
  display: 'flex',
  alignItems: 'center',
  padding: '$0',
});

export const NavigationListItemStyled = styled('li', {
  listStyleType: 'none',
  padding: '$0 $3',
});
